import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useSearchParams } from "react-router";
import { SubNav } from "../components/SubNav";
import Advances from "./expenses/Advances";
import Owed from "./expenses/Owed";
import Travel from "./expenses/Travel";
import { usePeopleCompany } from "./People";

/** Expense filing and employee advances (WP-24 wave N, HRX-05).
 *
 * Filing works: 24 claims, 18 approved and sanctioned at 7,950,000 CDF, every one with an approver and a
 * payable account. What had never run once was paying anybody — no Payment Entry against an Employee existed
 * anywhere on the site, and ten of those claims were over ninety days old. */

export const EXPENSE_SCREENS = ["advances", "travel"] as const;

export default function Expenses() {
  const { t } = useTranslation();
  const company = usePeopleCompany();
  const [params] = useSearchParams();
  const query = params.get("company") ? `?company=${encodeURIComponent(params.get("company")!)}` : "";

  const items = [
    { key: "owed", to: `/people/expenses${query}`, label: t("exp.tabs.owed"), end: true },
    ...EXPENSE_SCREENS.map((k) => ({ key: k, to: `/people/expenses/${k}${query}`, label: t(`exp.tabs.${k}`) })),
  ];

  return (
    <div data-expenses>
      <SubNav items={items} label={t("exp.sections")} />
      <Outlet context={{ company }} />
    </div>
  );
}

const useCompany = () => useOutletContext<{ company: string }>().company;

export const ExpensesIndex = () => <Owed company={useCompany()} />;
export const ExpensesAdvances = () => <Advances company={useCompany()} />;
export const ExpensesTravel = () => <Travel company={useCompany()} />;
